import * as React from "react";
import { SVGProps } from "react";

const Zcash = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2500 2500" {...props}>
    <defs>
      <linearGradient
        id="a"
        x1={782.84}
        x2={799.34}
        y1={165.91}
        y2={165.91}
        gradientTransform="rotate(-45 26055.877 126147.552) scale(122.41)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#cf8724" />
        <stop offset={1} stopColor="#fdce58" />
      </linearGradient>
    </defs>
    <g data-name="Layer 2">
      <g data-name="Layer 1">
        <path
          fill="url(#a)"
          d="M1263.05 2297.61c-569.6 0-1034.57-465.43-1034.57-1034.56 0-569.6 465.44-1034.57 1034.57-1034.57 569.6 0 1034.56 465.44 1034.56 1034.57 0 569.6-464.96 1034.56-1034.56 1034.56Z"
        />
        <path d="M1250 2500C562.5 2500 0 1937.5 0 1250S562.5 0 1250 0s1250 562.5 1250 1250-562.5 1250-1250 1250Zm0-2222.06c-534.56 0-972.06 437.5-972.06 972.06s437.5 972.06 972.06 972.06 972.06-437.5 972.06-972.06-437.5-972.06-972.06-972.06Z" />
        <path d="M1221.05 1588.59h541.67v270.84h-319.6v229.16h-277.94v-222.06H831.85c0-90.44-13.73-180.4 7.1-263.73 7.1-41.67 55.4-83.34 90.43-125 104.17-125 208.34-250 319.61-375 41.66-48.77 83.33-90.44 132.1-145.83H860.26V686.13h305.39V457h270.84v222h333.33c0 90.43 13.73 180.4-7.1 263.73-7.1 41.67-55.4 83.33-90.44 125-104.16 125-208.33 250-319.6 375-41.68 48.8-83.33 97.09-131.63 145.86Z" />
      </g>
    </g>
  </svg>
);

export default Zcash;
